import styled from 'styled-components';
import '@amzn/unified-data-table-components/styles/css/udc-theme.css';

export const UDCTableContainer = styled.div`
  width: 100%;
  overflow: visible;
  min-height: 25rem;

  &&& .ag-popup,
  &&& .ag-filter-popup,
  &&& .ag-popup-child,
  &&& .ag-menu {
    z-index: 99999;
    position: fixed;
  }

  &&& .ag-cell {
    overflow: visible;
  }

  &&& .ag-row {
    z-index: auto;
  }

  &&& .ag-row:hover {
    z-index: 1;
  }
`;
